module.exports = __webpack_public_path__ + "static/media/TomSerpento2.ef506590.jpg";